import getFormQuery from '../../../utils/getFormQuery';
import { ENDPOINTS } from '../../endpoints';
import { post } from '../../../utils/http/post';
import { parseQueryString } from '../../../utils/parseQueryString/parseQueryString';
import { assertResponseSuccess } from '../../../utils/loginError/loginError';

export async function loginWithMfa(post, code, loginQueryParams) {
  const otac = parseQueryString('otac', window.location.search);
  const result = await post(ENDPOINTS.MFA, {
    token: code,
    otac,
    loginQueryParams,
  });
  assertResponseSuccess(result);

  return result.body.redirectUrl;
}

export default code => loginWithMfa(post, code, getFormQuery(window.location.search));
